import React from "react";
import { Button, Modal } from "react-blueprint-library";
//This modal is used by Residential History and Education History with different messages which are passed as props from specific components as message
export default function EmploymentHistoryDeleteModal(props) {
  return (
    <>
      <div>
        <div id="deleteModal"></div>
        <div>
          <Modal
            id="deleteModal"
            show={props.isOpen}
            className="modal-md"
            title=""
          >
            {props.show_spinner === false && (
              <div>
                <div className="modal-body" id="top_delete_element">
                  <div className="container">
                    <div className="modal-header">
                      <h2>
                        <div>{props.message}</div>
                      </h2>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close modal dialog"
                        onClick={props.closeClick}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-link" onClick={props.closeClick}>
                      No, Never Mind
                    </button>
                    <Button
                      variant={"primary"}
                      id="add_button"
                      onClick={props.deleteClick}
                    >
                      Yes
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {props.show_spinner && (
              <>
                <div
                  className="row"
                  style={{ marginTop: "15px", height: "150px" }}
                >
                  <div
                    id="emp_hist_delete_loading"
                    className="mm-dots-loading-xl"
                    style={{ marginLeft: "225px", marginTop: "50px" }}
                  />
                </div>
              </>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
}
